"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setThreeVector3 = void 0;
function setThreeVector3(target, v) {
    target.set(v.x, v.y, v.z);
}
exports.setThreeVector3 = setThreeVector3;
